import { IWorkShiftTimeSlot } from "../workShiftTimeSlot/workShiftTimeSlot";

export interface WorkShiftDto {
    workShiftId: string;
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlots: IWorkShiftTimeSlot[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
}

export interface WorkShift {
    workShiftId: string;
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlotIds: string[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
}

export const getWorkShift = ({
    workShiftId,
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlots,
    startTimeZoneName,
    startTimePlannedWorkShiftId,
}: WorkShiftDto) => ({
    workShiftId,
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlotIds: workShiftTimeSlots.map((s) => s.id),
    startTimeZoneName,
    startTimePlannedWorkShiftId,
});
